/* Cosi Kids productpagina 2.0
   De aftelling in de leverbelofte, de VIP-punten die meebewegen met de
   gekozen maat, de maattabelknop naast het maatlabel en de knop "en meer"
   onder de betaalmethoden. Alleen geladen op het ck-producttemplate. */
(function () {
  /* ------------------------------------------------------------------
     Aftelling in de leverbelofte
     ------------------------------------------------------------------
     Serverside staat de juiste zin er al: "Voor 15:00 besteld, vandaag
     verzonden". Dit zet de resterende tijd er achter, in een eigen span,
     zolang die vandaag nog haalbaar is. Zo blijft de belofte staan als de
     aftelling om welke reden dan ook niet werkt; eerder overschreef dit de
     hele zin.

     Draait op de klok van de bezoeker, dus voor iemand in een andere tijdzone
     kan het een uur schelen. Dat is bewust: de serverside zin blijft de
     belofte, de aftelling is de aanmoediging. */
  function werkAftellingBij() {
    var blok = document.querySelector('[data-ck-lever]');
    if (!blok) return;

    var klok = blok.querySelector('[data-ck-lever-klok]');
    if (!klok) return;

    var grens = parseInt(blok.getAttribute('data-ck-grens'), 10);
    if (isNaN(grens)) return;

    var nu = new Date();
    var dag = nu.getDay();
    var werkdag = dag >= 1 && dag <= 5;
    if (!werkdag || nu.getHours() >= grens) {
      klok.hidden = true;
      return;
    }

    var deadline = new Date(nu.getFullYear(), nu.getMonth(), nu.getDate(), grens, 0, 0);
    var over = Math.floor((deadline - nu) / 1000);
    if (over <= 0) {
      klok.hidden = true;
      return;
    }

    var uren = Math.floor(over / 3600);
    var minuten = Math.floor((over % 3600) / 60);

    /* Minuten met een voorloopnul, zodat de regel niet in breedte springt
       terwijl de bezoeker ernaar kijkt. */
    var mm = minuten < 10 ? '0' + minuten : String(minuten);
    klok.textContent = uren > 0 ? '· nog ' + uren + ' u ' + mm + ' min' : '· nog ' + minuten + ' min';
    klok.hidden = false;
  }

  werkAftellingBij();
  setInterval(werkAftellingBij, 30000);

  /* ------------------------------------------------------------------
     Maattabelknop naast het label "Kies Maat"
     ------------------------------------------------------------------
     De knop wordt door het template boven de maten gerenderd, want daar staat
     het custom_liquid-blok. Hij hoort echter naast het label te staan: dat is
     de plek waar de twijfel ontstaat, en zo staat hij bij elk merk op dezelfde
     plek in plaats van te wisselen (punt P5 uit de review).

     Verplaatsen in plaats van er met negatieve marges overheen schuiven. Zo
     ontstaat er geen onzichtbaar vlak dat tikken opvangt; dat is in dit
     project al drie keer misgegaan. Lukt het verplaatsen niet, dan blijft de
     knop gewoon staan waar hij stond en werkt hij ook daar.

     De legend wordt door het thema opnieuw opgebouwd bij een maatwissel,
     vandaar dat dit ook na een change nog een keer draait. */
  function zetMaattabelknop() {
    var blok = document.querySelector('[data-ck-maattabel-blok]');
    if (!blok) return;

    var knop = blok.querySelector('.ck-maattabel__knop');
    var label = document.querySelector('.product-meta-option .form__label');
    if (!knop || !label) return;
    if (label.contains(knop)) return;

    label.appendChild(knop);
    blok.hidden = true;
  }

  zetMaattabelknop();

  /* ------------------------------------------------------------------
     Betaalmethoden: "en meer"
     ------------------------------------------------------------------
     De vijf methoden die er in Nederland toe doen staan op een rij; de rest
     staat op hidden. Deze knop klapt ze uit en verdwijnt daarna, want er valt
     dan niets meer te tonen. */
  document.addEventListener('click', function (event) {
    var knop = event.target.closest('[data-ck-betalen-meer]');
    if (!knop) return;

    var blok = knop.closest('[data-ck-betalen]');
    if (!blok) return;

    blok.querySelectorAll('.ck-betalen__item--extra').forEach(function (item) {
      item.hidden = false;
    });
    knop.setAttribute('aria-expanded', 'true');
    knop.hidden = true;
  });

  /* ------------------------------------------------------------------
     Geen voorgeselecteerde maat (M4, punt P3)
     ------------------------------------------------------------------
     Het thema vinkt de eerste leverbare maat aan. Dat leest als een keuze die
     de bezoeker al gemaakt heeft: de koopbalk zei "116 · €44,99 · In
     winkelmand" terwijl niemand 116 had aangewezen. Bij een winkel die één
     stuk per maat inkoopt is dat een dure vergissing.

     Nu staat er bij het laden niets aan en vraagt de knop om een maat.

     DRIE DINGEN OM TE ONTHOUDEN:

     1. Met ?variant= in de URL blijft de maat wél staan. Dat is een bewuste
        keuze van de bezoeker of van een mail, en die gooien we niet weg.
     2. Bij één maat (one size) blijft die gewoon aan staan; daar valt niets
        te kiezen.
     3. Het veld input[name="id"] van het thema houdt de eerste variant vast,
        ook als er niets aangevinkt is. Daarom hangt er een poort op het
        formulier zelf, in de capture-fase, vóór de afhandeling van het thema.
        Zowel de gewone knop als de koopbalk gaat via dat formulier (die
        laatste met requestSubmit), dus één poort dekt beide. Faalt dit script,
        dan blijft de oude situatie staan: een voorgeselecteerde maat die wel
        klopt. Het faalt dus nooit naar een verkeerde maat in het mandje. */
  (function geenVoorselectie() {
    var formulier = document.querySelector('form[data-type="add-to-cart-form"]');
    if (!formulier) return;

    var knop = Array.prototype.filter.call(
      formulier.querySelectorAll('[data-add-to-cart]'),
      function (k) { return !k.closest('.product-form__button--fixed'); }
    )[0] || formulier.querySelector('[data-add-to-cart]');
    if (!knop) return;

    var kiezer = document.querySelector('.product-meta-selector, variant-selects');

    /* De maatknoppen staan BUITEN het formulier: het thema zet
       variant-selects in .product-form__controls-group en het formulier
       daaronder, alleen om de koopknop heen. Gemeten op 2026-09-07, en het
       koste een testronde: zoeken binnen het formulier leverde nul knoppen op
       en dit hele blok sloeg zichzelf over. Vandaar document-breed. */
    var maten = document.querySelectorAll('.single-option-selector--box input[type="radio"]');

    function tekstVak() {
      return knop.querySelector('[data-add-to-cart-text]');
    }

    var origineleTekst = tekstVak() ? tekstVak().textContent : '';

    function zetKnop(tekst, uit) {
      var vak = tekstVak();
      if (vak) vak.textContent = tekst;
      if (uit) knop.setAttribute('aria-disabled', 'true');
      else knop.removeAttribute('aria-disabled');
    }

    function wijsMatenAan() {
      if (!kiezer) return;
      kiezer.scrollIntoView({ behavior: 'smooth', block: 'center' });
      kiezer.classList.add('ck-koopbalk__wijs-aan');
      setTimeout(function () { kiezer.classList.remove('ck-koopbalk__wijs-aan'); }, 1600);
    }

    function maatGekozen() {
      document.body.classList.remove('ck-geen-maat');
      zetKnop(origineleTekst, false);
    }

    /* Met een variant in de URL, of bij één maat, verandert er niets. */
    if (new URLSearchParams(window.location.search).get('variant')) return;
    if (maten.length < 2) return;

    var aangevinkt = document.querySelector('.single-option-selector--box input[type="radio"]:checked');
    if (!aangevinkt) return;

    /* NIET UITVINKEN. Dat was de eerste poging en die brak het kopen: de
       variantlogica van het thema raakt uit de pas zodra er niets aangevinkt
       is, werkt input[name="id"] daarna niet meer bij, en een tik op de
       koopknop deed vervolgens helemaal niets meer. Nagemeten op 2026-09-07
       met echte tikken en het winkelmandje uitgelezen.

       Wat wel werkt: de radio blijft aangevinkt, zodat het thema zijn eigen
       gang kan gaan, en wij halen alleen de selectie visueel weg (CSS op
       body.ck-geen-maat) en zetten een poort op het formulier. Het veld
       input[name="id"] wijst dan wel naar de eerste maat, maar er kan niets
       mee gebeuren: de poort laat pas door zodra de bezoeker echt een maat
       heeft aangewezen. */
    document.body.classList.add('ck-geen-maat');
    zetKnop('Kies je maat', true);

    formulier.addEventListener('submit', function (event) {
      if (!document.body.classList.contains('ck-geen-maat')) return;
      event.preventDefault();
      event.stopPropagation();
      wijsMatenAan();
    }, true);

    /* Ook document-breed luisteren, om dezelfde reden. */
    document.addEventListener('change', function (event) {
      if (!event.target.closest || !event.target.closest('.single-option-selector--box')) return;
      maatGekozen();
    });
  })();

  /* ------------------------------------------------------------------
     Teller in plaats van de thumbnailstrook (M4, punt P1 en P8)
     ------------------------------------------------------------------
     Op mobiel verdwijnt de strook van zeven thumbnails van 70 px; die kost
     ruimte en niemand tikt erop als je ook kunt vegen. In plaats daarvan een
     teller "1 / 7" rechtsonder in de foto, zodat zichtbaar blijft dat er meer
     foto's zijn.

     De carousel is slick. Die vuurt zijn eigen events af (afterChange), maar
     die zijn alleen te vangen met jQuery, en dat is hier niet gegarandeerd
     aanwezig. Vandaar de stand uit de DOM lezen: slick zet de klasse
     slick-current op de zichtbare slide. Een MutationObserver op de track
     ziet elke wissel, ook die van een veeg, en kan niet achterlopen zoals een
     IntersectionObserver dat zou doen.

     De thumbnails blijven in de DOM staan; ze zijn alleen met CSS verborgen
     onder 750 px. Zo blijft de carousel van het thema intact en werkt desktop
     ongewijzigd. */
  function zetFototeller() {
    var galerij = document.querySelector('.product__media-wrapper');
    if (!galerij) return;

    var track = galerij.querySelector('.slick-track');
    var slides = galerij.querySelectorAll('.product-single__gallery-item:not(.slick-cloned)');
    if (!track || slides.length < 2) return;

    var teller = galerij.querySelector('.ck-fototeller');
    if (!teller) {
      teller = document.createElement('span');
      teller.className = 'ck-fototeller';
      teller.setAttribute('aria-hidden', 'true');
      galerij.appendChild(teller);
    }

    function bijwerken() {
      var huidig = galerij.querySelector('.product-single__gallery-item.slick-current');
      var nummer = 1;
      if (huidig) {
        var index = parseInt(huidig.getAttribute('data-slick-index'), 10);
        if (!isNaN(index)) {
          /* slick telt klonen negatief door; modulo brengt het terug naar de
             echte reeks. */
          nummer = ((index % slides.length) + slides.length) % slides.length + 1;
        }
      }
      teller.textContent = nummer + ' / ' + slides.length;
    }

    bijwerken();
    new MutationObserver(bijwerken).observe(track, {
      attributes: true,
      attributeFilter: ['class'],
      subtree: true
    });
  }

  /* De carousel wordt door het thema opgebouwd nadat dit script draait, dus
     een paar keer proberen tot de track er is. */
  (function wachtOpGalerij(pogingen) {
    if (document.querySelector('.product__media-wrapper .slick-track')) {
      zetFototeller();
      return;
    }
    if (pogingen <= 0) return;
    setTimeout(function () { wachtOpGalerij(pogingen - 1); }, 300);
  })(20);

  /* ------------------------------------------------------------------
     VIP-punten meebewegend met de gekozen maat
     ------------------------------------------------------------------
     Verdienen: 10 punten per euro. Inwisselen: 100 punten is 1 euro. Beide
     staan in data-attributen op het blok, zodat een wijziging aan het
     programma op een plek gebeurt.

     Bij Cosi Kids heeft elke maat dezelfde prijs, dus in de praktijk
     verandert er niets. Toch meeluisteren: zodra er ooit een product komt
     waarbij de maten in prijs verschillen, klopt het bedrag meteen. We lezen
     de prijs uit het prijsblok van het thema in plaats van uit een eigen
     bron, zodat er een waarheid is. */
  function geld(centen) {
    return '€ ' + (centen / 100).toFixed(2).replace('.', ',');
  }

  function werkPuntenBij() {
    var blok = document.querySelector('[data-ck-vip]');
    if (!blok) return;

    var perEuro = parseInt(blok.getAttribute('data-ck-per-euro'), 10);
    var terug = parseInt(blok.getAttribute('data-ck-terug'), 10);
    if (isNaN(perEuro) || isNaN(terug) || terug === 0) return;

    var prijsEl = document.querySelector('.price__container .price-item--sale, .price__container .price-item--regular');
    if (!prijsEl) return;

    /* "€ 95,00" of "€95,00": alles behalve cijfers, punt en komma weg,
       daarna de komma als decimaalteken behandelen. */
    var ruw = prijsEl.textContent.replace(/[^0-9.,]/g, '').replace(/\./g, '').replace(',', '.');
    var euro = parseFloat(ruw);
    if (isNaN(euro) || euro <= 0) return;

    var punten = Math.floor(euro) * perEuro;
    var waardeCenten = Math.round((punten * 100) / terug);

    var aantal = blok.querySelector('[data-ck-vip-aantal]');
    var waarde = blok.querySelector('[data-ck-vip-waarde]');
    if (aantal) aantal.textContent = punten;
    if (waarde) waarde.textContent = geld(waardeCenten);
  }

  document.addEventListener('change', function (event) {
    if (!event.target.closest('variant-selects, variant-radios, .product-form__input')) return;
    setTimeout(function () {
      werkPuntenBij();
      zetMaattabelknop();
    }, 250);
  });
})();
